export const FROM_NAME = 'captcha';

export const CLOUD_SERVICE_PROTOCOL_URL = 'cloudServiceProtocolUrl';

export const CLOUD_SERVICE_PROTOCOL_HEADER_MAP = 'cloudServiceProtocolHeaderMap';